import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import { organizationsQueryOptions } from "../api/queries";

export const Route = createFileRoute("/organization")({
  loader: async ({ context }) => {
    try {
      await context.queryClient.ensureQueryData(
        organizationsQueryOptions(context.getToken),
      );
    } catch {
      // Graceful failure — Clerk may not be ready yet.
    }
  },
  component: OrganizationLayout,
});

function OrganizationLayout() {
  return (
    <>
      <SignedIn>
        <Outlet />
      </SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}
